module.exports = __webpack_public_path__ + "img/blue-ribbon.044c6917.svg";